const RawType = {
  xdiv: "x-div",
  li: "li",
  div: "div",
};

const rawRowType = (rowType) => {
  if (rowType.startsWith("html-")) {
    return rawRowType(rowType.slice(5));
  }
  if (rowType.startsWith("li")) {
    return RawType.li;
  }
  if (rowType.startsWith("x-div")) {
    return RawType.xdiv;
  }
  return RawType.div;
};

const cleanXDiv = () => ["x-div", ""];
export const fixEduDescription = (description) => {
  // insert x-divs
  // skip if next element is x-div
  // after a div, if it is not the last element
  // after li, if next element is not li
  const newDescription = [];
  for (let i = 0; i < description.length; i++) {
    const el = description[i];
    newDescription.push(el);
    if (i === description.length - 1) {
      continue;
    }
    const nextEl = description[i + 1];
    if (
      rawRowType(nextEl[0]) === RawType.xdiv ||
      rawRowType(el[0]) === RawType.xdiv
    ) {
      continue;
    }
    if (rawRowType(el[0]) === RawType.div) {
      newDescription.push(cleanXDiv());
    }
    if (
      rawRowType(el[0]) === RawType.li &&
      rawRowType(nextEl[0]) !== RawType.li
    ) {
      newDescription.push(cleanXDiv());
    }
  }
  return newDescription;
};

export const urlId_eduId = (urlId) => {
  return urlId - 1000;
};

export const eduId_urlId = (eduId) => {
  return eduId + 1000;
};
